import { initFirstTouchCapture } from './core/growth/acquisition.js';

// Minimal first-touch attribution capture for entry pages that do not load the
// full quote core (for example marketing or blog landing pages). It stashes the
// acquisition source of a consenting visitor's first page so it survives the
// journey to a saved estimate. Add this one module to any page that can be an
// entry point; pages that already load dwellow-core capture the same first touch
// and do not also need this.
initFirstTouchCapture();

if (typeof window !== 'undefined') {
    const dwellow = window.Dwellow = window.Dwellow || {};
    dwellow.growth = dwellow.growth || {};
    dwellow.growth.initFirstTouchCapture = initFirstTouchCapture;
}
